import React from 'react';

export const WorkerRadioText = ({ name, value, disabled }) => {
  return disabled ? (
    <span>{value}</span>
  ) : (
    <input type='text' name={name} value={value} disabled={disabled} />
  );
};



// WEBPACK FOOTER //
// ./src/components/worker/WorkerRadioText.jsx